import { Injectable } from '@angular/core';
import { BotMessagesService } from './bot-messages.service';

/**
 * Liefert Informationen über den aktuellen Bot-Zustand (`RAGAI.INFO`).
 * @remarks
 * Aktuell nur ein sehr dünner Wrapper um {@link BotMessagesService.getMessageCount} - Platzhalter-Modul für
 * zukünftige, weitere Statusabfragen (Namensgebung deutet auf breiteren geplanten Umfang hin).
 */
@Injectable({
  providedIn: 'root'
})
export class InfoManagerService {

  constructor(
    private botMessagesService: BotMessagesService
  ) { }

  /**
   * Gibt die Anzahl der Nachrichten im aktuellen Verlauf zurück.
   * @returns Anzahl der Nachrichten.
   */
  public messagesCount() {
    return this.botMessagesService.getMessageCount();
  }
}
